import { downloadFile, getIdOrNull } from '..'
import apiClient from './apiClient'

export const consumeInternalToken = (token, body = {}) => apiClient.patch(null, `api/internal-tokens/${token}/consume`, body)

export const approveInternshipRequestByToken = (token, requestPeriods) => consumeInternalToken(token, { isApproved: true, requestPeriods })
export const refuseInternshipRequestByToken = (token) => consumeInternalToken(token, { isApproved: false })

export const downloadInternshipRequestFileByToken = (token, file) => downloadFile(
  `/api/internal-tokens/${token}/internship-documents/${getIdOrNull(file)}`,
  file.originalName,
  null
)
